export const ANALYTICS_PACKAGE_NAME = 'jiraIssueNavigatorCustomFilters';
